import React from "react";

interface ShadowCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export default function ShadowCard({
  children,
  className = "",
  ...props
}: ShadowCardProps) {
  return (
    <div
      className={`relative rounded-2xl border-2 border-[#EE4137] bg-black/40 shadow-[2px_2px_15px_0px_#EE4137] backdrop-blur-sm transition-all duration-300 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
